<template>
	<AR/>
</template>

<script>
	import AR from './components/AR.vue'

	export default {
		name: 'App',
		components: {
			AR
		}
	}
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,700&display=swap');
	@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,700&display=swap');

	* {
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		-webkit-text-size-adjust: 100%;
	}
	html {
		font-family: 'Montserrat', sans-serif;
		-webkit-text-size-adjust: 100%;
		-ms-text-size-adjust:     100%;
		font-size: 14px;
		line-height: 1.2;
	}
	body.screenshot-mode{
		overflow: hidden;
	}
	a,
	a:visited,
	a:hover,
	a:focus,
	a:active {
		color: inherit;
	}
	.main-column {
		position: relative;
		margin: 0 auto;
		height: auto;
		width: 1200px;
	}
	.column-of-1 { width: 100% }
	.column-of-2 { width: 50% }
	.column-of-3 { width: 33.33% }
	.double-column-of-3 { width: 66.66% }
	.column-of-4 { width: 25% }
	.column-of-5 { width: 20% }

	.columns-1 { width: 8.33% }
	.columns-2 { width: 16.66%; }
	.columns-3 { width: 25%; }
	.columns-4 { width: 33.33%; }
	.columns-5 { width: 41.66%; }
	.columns-6 { width: 50%; }
	.columns-7 { width: 58.33%; }
	.columns-8 { width: 66.66%; }
	.columns-9 { width: 75%; }
	.columns-10 { width: 83.33%; }
	.columns-11 { width: 91,66%; }
	.columns-12 { width: 100%; }

	.column-of-1,
	.column-of-2,
	.column-of-3,
	.double-column-of-3,
	.column-of-4,
	.column-of-5,
	.columns-1,
	.columns-2,
	.columns-3,
	.columns-4,
	.columns-5,
	.columns-6,
	.columns-7,
	.columns-8,
	.columns-9,
	.columns-10,
	.columns-11,
	.columns-12{
			position: relative;
	}
	.outer-margins{
		margin: 0 -10px;
	}
	.large-outer-margins{
		margin: 0 -20px;
	}
	.small-col-padding{
		padding-left: 10px;
		padding-right: 10px;
	}
	.col-padding {
		padding-left: 20px;
		padding-right: 20px;
	}
	.double-col-padding {
		padding-left: 40px;
		padding-right: 40px;
	}
	.small-row-padding{
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.row-padding {
		padding-top: 20px;
		padding-bottom: 20px;
	}
	.double-row-padding {
		padding-top: 40px;
		padding-bottom: 40px;
	}
	.left { position: relative; float: left; }
	.right { position: relative; float: right; }
	.center {
		position: relative;
		margin: 0 auto;
	}
	.clear { clear: both; }
	.cover{
		background-size: cover;
		background-position: center;
		object-fit: cover;
		-o-object-fit: cover;
		object-position: center;
	}
	ul li{
		list-style: none;
	}
	.uppercase{
		text-transform: uppercase;
	}
	.bold{
		font-weight: 700;
	}
	.very-small-font{
		font-size: 0.71rem;
	}
	.small-font{
		font-size: 0.86rem;
	}
	.medium-font{
		font-size: 1.14rem;
	}
	.large-font{
		font-size: 1.43rem;
	}
	.very-large-font{
		font-size: 2.14rem;
	}
	.align-center{
		text-align: center;
	}
	.align-right{
		text-align: right;
	}
	.flex{
		display: flex;
	}
	.flex.space{
		justify-content: space-between;
	}
	.flex.center{
		justify-content: center;
	}
	.flex.v-center {
		align-items: center;
	}
	.flex.h-center {
		justify-content: center;
	}
	.flex.h-end {
		justify-content: flex-end;
	}
	.button{
		display: inline-block;
		text-transform: uppercase;
		padding: 10px 25px;
		border: 2px solid white;
		border-radius: 20px;
		line-height: 1;
		cursor: pointer;
	}
	select{
		border: none;
		border-bottom: 1px solid black;
		padding: 10px 0;
	}
	
	/* TRANSITIONS */
	
	.fade-enter-active,
	.fade-leave-active {
	  transition: opacity 0.5s ease;
	}

	.fade-enter-from,
	.fade-leave-to {
	  opacity: 0;
	}

	.slow-fade-enter-active,
	.slow-fade-leave-active {
		transition: opacity 1s ease;
	}

	.slow-fade-enter-from,
	.slow-fade-leave-to {
	  opacity: 0;
	}
	
	
	@media screen and (max-width: 1260px) {
		.main-column{
			width: 95% !important;
		}
	}

	@media screen and (max-width: 767px) {
		.showOnMobile{
			display: block;
		}
		.dontShowOnMobile {
			display: none;
		}
	}
	
	@media screen and (max-width: 599px) {
		html{
			font-size: 12px;
		}
	}
</style>
